import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Alert } from 'react-bootstrap';
import { Input } from '../common/components/formControls';
import validators from '../common/services/validators';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleRight, faUser } from '@fortawesome/free-solid-svg-icons';

const ForgottenPasswordForm = ({ error, handleSubmit, submitSucceeded, pristine, submitting, t, email }) => {

	return (
		<form onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && email && <Alert bsStyle='success'>{t('ForgottenPassword_SendEmailSuccess', { email })}</Alert>}
			<Field name='username' component={Input} type='text' placeholder={t('ForgottenPassword_Username')} icon={faUser} validate={validators.required} />
			<div className='form-actions'>
				<Link to='/login' className='btn btn-default'>{t('ForgottenPassword_Back')}</Link>
				<Button type='submit' disabled={pristine || submitting} className='btn-bricky pull-right'>
					{t('ForgottenPassword_Send')} <FontAwesomeIcon icon={faArrowCircleRight} />
				</Button>
			</div>
		</form>
	);
};

ForgottenPasswordForm.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'forgottenPassword' })(withTranslation()(ForgottenPasswordForm));